<i18n locale="en">
{
  "title": "Welcome Back",
  "subtitle": "Sign in below to manage your Owner website and more."
}
</i18n>

<template>
  <FeaturesLayout centered>
    <TitleBlock :title="t('title')" :subtitle="t('subtitle')" variant="large" />
    <LoginPageContent />
  </FeaturesLayout>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import TitleBlock from '@/components/typography/TitleBlock.vue'

import FeaturesLayout from '../components/common/FeaturesLayout.vue'
import LoginPageContent from '../components/login/LoginPageContent.vue'
import { useRedirectIfLoggedIn } from '../composables/useRedirectIfLoggedIn'

const { t } = useI18n()
useRedirectIfLoggedIn()
</script>
